// KPMG theme was broken when figma tokens where introduced
// It would be fixed by uncommenting the following lines
// but it would change currently used colors
// It should be confirmed with KPMG first

// const base = "#00338d";

export const kpmgVariables = {
  // paletteBlue0Light: base,
  // palettePrimary0Light: "#0043b8",
  // palettePrimary2Light: "#275ddd"
};
